export type BulkTablePasteMode = 'replace' | 'append';

export const parseTabularClipboard = (text: string): string[][] => {
  const rows: string[][] = [];
  let currentCell = '';
  let currentRow: string[] = [];
  let inQuotes = false;

  for (let index = 0; index < text.length; index += 1) {
    const char = text[index];
    const nextChar = text[index + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        currentCell += '"';
        index += 1;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }

    if (!inQuotes && char === '\t') {
      currentRow.push(currentCell);
      currentCell = '';
      continue;
    }

    if (!inQuotes && (char === '\n' || char === '\r')) {
      if (char === '\r' && nextChar === '\n') index += 1;
      currentRow.push(currentCell);
      rows.push(currentRow);
      currentRow = [];
      currentCell = '';
      continue;
    }

    currentCell += char;
  }

  currentRow.push(currentCell);
  rows.push(currentRow);
  return rows.filter((row) => row.some((cell) => cell.trim() !== ''));
};

export const isBlankBulkTableRow = (row: unknown[]) =>
  row.every((value) => String(value ?? '').trim() === '');

export const ensureBulkTableRows = (
  rows: unknown[][],
  columnCount: number,
  minimumRows: number,
): unknown[][] => {
  const normalisedRows = rows.map((row) =>
    Array.from({ length: columnCount }, (_unused, columnIndex) => row[columnIndex] ?? ''),
  );
  while (normalisedRows.length < minimumRows) {
    normalisedRows.push(Array.from({ length: columnCount }, () => ''));
  }
  return normalisedRows;
};

export const mergeBulkTableRows = (
  currentRows: unknown[][],
  pastedRows: unknown[][],
  mode: BulkTablePasteMode,
): unknown[][] => {
  if (mode === 'replace') return pastedRows;
  return [...currentRows.filter((row) => !isBlankBulkTableRow(row)), ...pastedRows];
};

export const getBulkTableClipboardColumnError = (
  rows: unknown[][],
  expectedColumnCount: number,
): string | undefined => {
  const hasInvalidRow = rows.some((row) => row.length !== expectedColumnCount);
  if (!hasInvalidRow) return undefined;

  return `Clipboard data must have exactly ${expectedColumnCount} column${expectedColumnCount === 1 ? '' : 's'} per row.`;
};
